import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
// import { createBeneficiary, updateBeneficiaryById, getBeneficiaryById } from "../../../../../services/beneficiary.service";
import { TBeneficiaryForm, beneficiarySchema } from "./beneficiarySchema";
import { AutoComplete, FormContainer, Treturn } from "@4uhub/lib4uhub";
import { beneficiaryItems, ownershipOptions } from "../beneficiary.mock";
import { Checkboxes } from "./Checkboxes";

interface IBeneficiaryProps {
  id?: string;
  onBackButton: () => void;
}

const translationPath = "page.4uDlist.generationRule.beneficiary.";

export const Beneficiary = memo(({ id, onBackButton }: IBeneficiaryProps) => {
  const { t } = useTranslation();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createBeneficiary
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateBeneficiaryById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getBeneficiaryById
  //   );

  const saveHandler = async (v: TBeneficiaryForm) => {
    // save({
    //   ...v,
    // });
    return { data: {}, success: true };
  };

  const updateHandler = async (v: TBeneficiaryForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TBeneficiaryForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TBeneficiaryForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      //   return { data, success };

      const data = beneficiaryItems.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  const successHandle = () => {
    onBackButton();
  };

  //   const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TBeneficiaryForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      //   loading={loading}
      title={t(translationPath + "beneficiary")}
      schema={beneficiarySchema}
      subtitle={t(translationPath + "new_beneficiary")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={successHandle}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      defaultValues={{ ownership: ownershipOptions[0].label }}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" fontWeight="bold">
              {t(translationPath + "ownership")}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Checkboxes />
          </Grid>
        </Grid>
      )}
    />
  );
});
